import React from 'react';

import { AvGroup } from 'availity-mobx-reactstrap-validation';
import QtyInput from './QtyInput';

export default props => (
  <AvGroup>
    <QtyInput {...props} />
  </AvGroup>
);
